import { useMutation, useQueryClient } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';

type UpdateRolePayload = {
  user_id: string;
  new_role: 'user' | 'admin' | 'auditor';
};

async function updateUserRole(payload: UpdateRolePayload): Promise<void> {
  const { data, error } = await supabaseClient.functions.invoke('admin-update-role', {
    method: 'POST',
    body: payload,
  });

  if (error) throw new Error(error.message ?? 'Failed to update role');
  if (!data?.data?.success) throw new Error('Failed to update role');
}

const useUpdateUserRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateUserRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-users'] });
    },
  });
};

export default useUpdateUserRole;
